function fn_comp_catalog() {
    var $fn = $(".comp_catalog"),
        $slider = $fn.find("[data-slider]"),
        $slider_autoplay = $slider.data("slider"),
        $slider_items = $slider.data("slider-items"),
        $slider_prev = $fn.closest("section").find("[data-slider-prev]"),
        $slider_next = $fn.closest("section").find("[data-slider-next]");

    $fn.find(".elm_nav .elm_item").hover(
        function() {
            $(this).closest(".elm_nav").find(".elm_item").addClass("mod--hover");
        }, function() {
            $(this).closest(".elm_nav").find(".elm_item").removeClass("mod--hover");
        }
    );

    $slider.slick({
        infinite: false,
        autoplay: true,
        autoplaySpeed: $slider_autoplay,
        dots: false,
        arrows: false,
        slidesToShow: $slider_items,
        slidesToScroll: 1,
        prevArrow: '<button type="button" class="slick-prev icon--chevron-left"></button>',
        nextArrow: '<button type="button" class="slick-next icon--chevron-right"></button>',
        speed: 500,
        touchMove: true,
        draggable: true,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });

    $slider_prev.on("click", function() {
        $slider.slick("slickPrev");
    });

    $slider_next.on("click", function() {
        $slider.slick("slickNext");
    });
}